module.exports = __webpack_public_path__ + "assets/img/lx_product_w.a40b7bdd.png";